/* PastéBCN — Reviews
   Web Component <pb-reviews>:
   - IntersectionObserver para animación de entrada (.is-visible)
   - Timeout de 5s para detectar si el widget de la app cargó.
     Si tras 5s el slot está vacío (sin altura útil ni texto), oculta
     el slot y muestra el fallback con link al GBP.
   - Respeta prefers-reduced-motion. */

if (!customElements.get('pb-reviews')) {
  class PbReviews extends HTMLElement {
    connectedCallback() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.slot = this.querySelector('[data-pb-reviews-slot]');
      this.skeleton = this.querySelector('.pb-reviews__skeleton');
      this.fallback = this.querySelector('.pb-reviews__fallback');

      this._observers = [];
      this._observeEntry();
    }

    disconnectedCallback() {
      this._observers.forEach((o) => o.disconnect());
      this._observers = [];
      if (this._fallbackTimer) clearTimeout(this._fallbackTimer);
    }

    _observeEntry() {
      const showVisible = () => this.classList.add('is-visible');
      const startCheck = () => this._scheduleFallbackCheck();

      if (this.reducedMotion || typeof IntersectionObserver === 'undefined') {
        showVisible();
        startCheck();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              showVisible();
              startCheck();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this);
      this._observers.push(observer);
    }

    _scheduleFallbackCheck() {
      // Solo monitoriza si el cliente añadió el app block. Sin block,
      // mostrar el skeleton + empty hint indefinidamente (estado de configuración).
      if (this.dataset.hasBlocks !== 'true') return;
      if (!this.slot || !this.fallback) return;
      this._fallbackTimer = setTimeout(() => this._checkWidget(), 5000);
    }

    _checkWidget() {
      if (!this.slot) return;
      // Considera "cargado" si el slot tiene altura útil o texto.
      const text = (this.slot.innerText || '').trim();
      const height = this.slot.offsetHeight;
      const hasContent = text.length > 20 || height > 80;

      if (hasContent) {
        if (this.skeleton) this.skeleton.hidden = true;
        return;
      }

      // Widget no cargó: oculta slot + skeleton, muestra fallback.
      this.slot.hidden = true;
      if (this.skeleton) this.skeleton.hidden = true;
      this.fallback.hidden = false;
    }
  }

  customElements.define('pb-reviews', PbReviews);
}
